import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_quiz = _resolveComponent("quiz")!
  const _component_utils = _resolveComponent("utils")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_quiz),
    _createVNode(_component_utils)
  ], 64))
}